module.exports = __webpack_public_path__ + "img/_blog2_1.82dc7573.png";